import { LOGOUT, LOGOUT_FAILURE, LOGOUT_SUCCESS } from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const logoutReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGOUT:
      return { ...state, loading: true };
    case LOGOUT_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case LOGOUT_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default logoutReducer;
